export const images = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/b08335bc-ac54-4624-b504-53be1d42048b.jpg",
  male: "https://cdn.magicpatterns.com/patterns/generated-images/befd48b2-9c60-4730-9145-f09573ad58cf.jpg",
  female: "https://cdn.magicpatterns.com/patterns/generated-images/57502760-00a2-4ee5-9eff-d0c4e4e99d90.jpg",
  kitten: "https://cdn.magicpatterns.com/patterns/generated-images/04f1be15-c883-4f46-a0b5-24bf42e5d283.jpg",
  home: "https://cdn.magicpatterns.com/patterns/generated-images/c3932422-9b9f-4642-a9dc-fe3407d7d27b.jpg",
};

export const navLinks = [
  { label: "La chatterie", href: "#chatterie" },
  { label: "Nos bengals", href: "#bengals" },
  { label: "Chatons", href: "#chatons" },
  { label: "Adoption", href: "#adoption" },
  { label: "Le Bengal", href: "#race" },
];

export const pillars = [
  {
    title: "Santé",
    text: "Chaque reproducteur est testé pour les maladies génétiques (PRA-b, PK-Def, HCM, PKD) et contagieuses (FIV, FeLV, coryza, parasites intestinaux).",
  },
  {
    title: "Tempérament",
    text: "Des chats équilibrés, sociables et confiants, élevés au cœur de la maison, au contact quotidien des humains.",
  },
  {
    title: "Beauté sauvage",
    text: "Une sélection rigoureuse des lignées pour des rosettes contrastées, un pelage glitter et une silhouette athlétique.",
  },
];

export const breeders = [
  {
    name: "Ozzy",
    role: "Mâle reproducteur",
    coat: "Brown spotted rosetted",
    image: images.male,
    tests: "PRA-b · PK-Def · HCM N/N",
  },
  {
    name: "Luna",
    role: "Femelle reproductrice",
    coat: "Silver spotted rosetted",
    image: images.female,
    tests: "PRA-b · PK-Def · PKD N/N",
  },
  {
    name: "Nala",
    role: "Femelle reproductrice",
    coat: "Brown spotted rosetted",
    image: images.hero,
    tests: "PRA-b · PK-Def · HCM N/N",
  },
];

export type KittenStatus = "Disponible" | "Réservé";

export const kittens: {
  name: string;
  sex: "Mâle" | "Femelle";
  coat: string;
  parents: string;
  born: string;
  status: KittenStatus;
  image: string;
}[] = [
  { name: "Simba", sex: "Mâle", coat: "Brown rosetted", parents: "Ozzy × Nala", born: "Août 2026", status: "Disponible", image: images.kitten },
  { name: "Saphir", sex: "Femelle", coat: "Silver rosetted", parents: "Ozzy × Luna", born: "Août 2026", status: "Disponible", image: images.female },
  { name: "Tao", sex: "Mâle", coat: "Brown rosetted", parents: "Ozzy × Nala", born: "Août 2026", status: "Réservé", image: images.male },
  { name: "Kenya", sex: "Femelle", coat: "Brown rosetted", parents: "Ozzy × Nala", born: "Août 2026", status: "Réservé", image: images.kitten },
];

export const adoptionSteps = [
  {
    title: "Premier contact",
    text: "Vous nous écrivez pour présenter votre foyer et votre projet. Nous échangeons par téléphone pour faire connaissance.",
  },
  {
    title: "Réservation",
    text: "Un acompte confirme la réservation de votre chaton. Vous recevez photos et nouvelles régulières pendant sa croissance.",
  },
  {
    title: "Visite à la chatterie",
    text: "Vous rencontrez votre chaton et ses parents en Ardèche, à 1h30 de Lyon, dans leur environnement familial.",
  },
  {
    title: "Départ à 12 semaines",
    text: "Votre chaton part vacciné, identifié, vermifugé, inscrit au LOOF, avec son kit de départ et un contrat de vente.",
  },
];

export const breedFacts = [
  { label: "Origine", value: "Croisement du chat léopard d'Asie et du chat domestique, reconnu dans les années 1980." },
  { label: "Caractère", value: "Joueur, intelligent, très attaché à sa famille. Il aime l'eau, apprend les jeux et suit ses humains partout." },
  { label: "Morphologie", value: "Athlétique et musclé, de 4 à 7 kg. Pelage court, soyeux, souvent pailleté (glitter)." },
  { label: "Robes", value: "Brown, silver, snow — en motifs spotted rosetted ou marbled." },
  { label: "Espérance de vie", value: "12 à 16 ans, avec un suivi vétérinaire régulier et une alimentation de qualité." },
];

export const included = [
  "Vaccins & primo-vaccination",
  "Puce d'identification I-CAD",
  "Pedigree LOOF",
  "Certificat vétérinaire",
  "Kit de départ",
  "Contrat de vente",
];
